import Apps from 'store/apps.resource';
import Advers from 'store/advertisers.resource';

export default function createSDRouteCtxMixin ({ onChange }) {
  return {
    data: () => ({
      app: null,
      // adver: null,
      Advers,

      SDRouteCtx: null,
      SDRouteCtxUpdateFix: 0,
    }),

    computed: {
      appId () { return Number(this.$route.params.appId) || null },
      adverId () { return Number(this.$route.params.adverId) || null },

      adver () {
        return this.Advers.ready && this.Advers.byId[this.adverId];
      },

      isSDRouteCtxPath () {
        return Number(this.$route.params.adverId) || null;
      },

      ctxParams () {
        const params = {};
        if (this.appId)
          params.appId = this.appId;
        if (this.adverId)
          params.advertiserId = this.adverId;
        return params;
      },
    },

    methods: {
      updateSDRouteCtx (
        { adverId = null, appId = null } = { adverId: this.adverId, appId: this.appId },
      ) {
        // return;
        console.log('SDRouteCtx: updateSDRouteCtx()', { adverId, appId });
        // const { adverId, appId } = this;

        // if (appId === this._lastAppId || appAdverId === prevAppAdverId) {
        //   // console.log('Root.onAppIdChange', 'STOP');
        //   return;
        // }
        this.SDRouteCtxUpdateFix++;
        if (this._lastContext
            && this._lastContext.adverId === adverId
            && this._lastContext.appId === appId
        ) {
          console.log('SDRouteCtx.js:_lastContext', this._lastContext);
          return;
        }
        this._lastContext = { adverId, appId };

        // console.log('updateSDRouteCtx continue');
        if (!appId && !adverId) {
          this.SDRouteCtx = null;
          this.app = null;
          // this.adver = null;
          this[onChange]?.(null);
          console.log('SDRouteCtx.js: nothing');
          return;
        }

        const app = Apps.byId[appId];
        const adver = Advers.byId[adverId];

        this.SDRouteCtx = (app && !app.$deleted && app) || (adver && !adver.$deleted && adver) || null;
        // this.SDRouteCtx = !!SDRouteCtx;
        // console.log('SDRouteCtx', SDRouteCtx)
        // console.log('Root.onAppIdChange', appId, prevAppId, this._lastAppId);
        if (this.SDRouteCtx) {
          // console.log('Root.onAppIdChange', this.app?.id, appId);
          if (this.app?.id !== appId || this.adver?.id !== adverId) {
            this[onChange]?.({ app, adver });
            // DataSources.fetch({ params: { appId, adverId } });
            // AdsAccs.fetch({ params: { appId, adverId } });
          }
          this.app = app;
          // this.adver = adver;
        } else {
          this._lastContext = null;
          this[onChange]?.(null);
          console.log('SDRouteCtx.js: nothing end');
          // DataSources.reset();
          // AdsAccs.reset();
        }
      },
    },

    watch: {
      adverId (adverId, prevAdverId = null) {
        console.log('SDRouteCtx: adverId.watcher: ', { adverId, prevAdverId });
        if (adverId && adverId !== prevAdverId)
          this.updateSDRouteCtx({ adverId });
      },

      // appId (appId, prevAppId = null) {
      //   console.log('onAppIdChange: ', { appId, prevAppId });
      //   if (appId && appId !== prevAppId)
      //     this.updateSDRouteCtx({ appId });
      // },
    },
  };
}
